import { render } from "./InputHankaku.vue?vue&type=template&id=4a803b14"
import script from "./InputHankaku.vue?vue&type=script&lang=js"
export * from "./InputHankaku.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__